import React, { useContext, useState } from 'react';

import { ApplicationUIContext, Table, useDrawerState } from '@yuhuinc/ui-library';
import { Typography, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import { getTranslatedString } from 'helpers/i18n';

import { CurrentApplicationContext } from '../../ApplicationOverview';
import ReferenceDrawer from './ReferenceDrawer';

const { Title, Link } = Typography;

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.applicationOverview.review.${key}`);

const getColumns = ({ onEdit, editEnabled }) => [
  {
    title: translate('references.name'),
    dataIndex: 'name',
    key: 'name',
    width: '30%',
    render(value) {
      return <Link href="#">{value}</Link>;
    },
  },
  {
    title: translate('references.referenceFor'),
    dataIndex: 'referenceFor',
    key: 'referenceFor',
    width: '30%',
  },
  {
    title: translate('references.referenceType'),
    dataIndex: 'reference_type',
    key: 'reference_type',
    width: '30%',
    render: (text) => translate(`references.referenceDrawer.${text}`),
  },
  {
    key: 'actions',
    render(_, record) {
      return (
        <Button
          type="link"
          onClick={() => onEdit(record)}
          disabled={!editEnabled}
          icon={<EditOutlined />}
        />
      );
    },
  },
];

const References = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);
  const [, editReferenceDrawer] = useDrawerState(false);
  const [currentReference, setCurrentReference] = useState(null);

  const references = application.cotenants.flatMap((cotenant) =>
    cotenant.references.map((reference) => ({
      referenceFor: cotenant.full_name,
      ...reference,
    }))
  );

  const onEdit = (reference) => {
    editReferenceDrawer.open();
    setCurrentReference(reference);
  };

  return (
    <>
      <Title level={isMobile ? 4 : 5}>{translate('references')}</Title>
      <Table
        dataSource={references}
        rowKey="id"
        columns={getColumns({ onEdit, editEnabled: application.can_review })}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        pagination={{ hideOnSinglePage: true }}
      />

      <ReferenceDrawer
        reference={currentReference}
        isVisible={editReferenceDrawer.isVisible}
        onClose={() => {
          editReferenceDrawer.close();
          setCurrentReference(null);
        }}
      />
    </>
  );
};

export default References;
